<template>
	<div class="age-dapp-container">
		<!-- 返回按钮 -->
		<button class="age-back-button" @click="handleBackClick" :disabled="isLoading">
			
			<span data-lang="t_217"></span>
		</button>

		<!-- AGE DApp 主内容区域 -->
		<div class="age-main-content">
			<h2>AGE </h2>
			<div class="age-info-section">
				<p style="text-align: left;" data-lang="t_218"></p>
				<div class="age-stats">
					<div class="stat-item">
						
						<div class="row" >
							<div class="title" >
								<span class="stat-value" style="text-align: center;font-size: 18px;">AGE NODE</span>
							</div>
							<div >1.0.3</div>
						</div>
					</div>
					
					<div class="stat-item">
						<div class="title">
							<div class="row" >
								<div class="title" data-lang="t_219">
									
								</div>
								<button class="btn btn-link" @click="btnCopyAddress(usdtAddress)">COPY -&gt;</button>
							</div>
						</div>
						<div class="stat-value">{{usdtAddress}}</div>
					</div>
					
					<div class="stat-item">
						<div class="title">
							<div class="row" >
								<div class="title" data-lang="t_220">
									
								</div>
								<button class="btn btn-link" @click="btnCopyAddress(TokenCon)">COPY -&gt;</button>
							</div>
						</div>
						<div class="stat-value">{{TokenCon}}</div>
					</div>
					
					<div class="stat-item">
						<div class="title">
							<div class="row" >
								<div class="title" data-lang="t_221">
									
								</div>
								<button class="btn btn-link" @click="btnCopyAddress(poolMine)">COPY -&gt;</button>
							</div>
						</div>
						<div class="stat-value">{{poolMine}}</div>
					</div>
					
					<div class="stat-item">
						<div class="title">
							<div class="row" >
								<div class="title" data-lang="t_222">
									
								</div>
								<button class="btn btn-link" @click="btnCopyAddress(poolProfit)">COPY -&gt;</button>
							</div>
						</div>
						<div class="stat-value">{{poolProfit}}</div>
					</div>
					<div class="stat-item">
						<div class="title">
							<div class="row" >
								<div class="title" data-lang="t_223">
									
								</div>
								<button class="btn btn-link" @click="btnCopyAddress(poolBouns)">COPY -&gt;</button>
							</div>
						</div>
						<div class="stat-value">{{poolBouns}}</div>
					</div>
					
					<div class="stat-item">
						<div class="title">
							<div class="row" >
								<div class="title" data-lang="t_224">
									
								</div>
								<button class="btn btn-link" @click="btnCopyAddress(poolExc)">COPY -&gt;</button>
							</div>
						</div>
						<div class="stat-value">{{poolExc}}</div>
					</div>
					<div class="stat-item">
						<div class="title">
							<div class="row" >
								<div class="title" data-lang="t_225">
									
								</div>
								<button class="btn btn-link" @click="btnCopyAddress(poolDestory)">COPY -&gt;</button>
							</div>
						</div>
						<div class="stat-value">{{poolDestory}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AgeDApp',
		data() {
			return {
				isLoading: false,
				TokenCon:"",
				poolMine:"",
				poolProfit:"",
				poolBouns:"",
				poolExc:"",
				poolDestory:"",
				usdtAddress:""
			}
		},
		methods: {
			setLanguage(){
				const elements = document.querySelectorAll('[data-lang]');
				
				elements.forEach(element => {
				    const langValue = element.getAttribute('data-lang');
					
				    element.innerHTML = Lang[lg][langValue];
				});
			},
			handleBackClick() {
				// 设置加载状态
				this.isLoading = true;
				setTimeout(() => {
					// 触发自定义事件，通知父组件
					this.$emit('data-received', {
						message: 'profile',
					});

					// 重置加载状态
					this.isLoading = false;
				}, 300);
			},
			btnCopyAddress(addr) { //Copy钱包
				copyRefURL(addr);
			},
		},
		mounted() {
			this.setLanguage();
			this.TokenCon = addrAGE;
			this.poolMine = addrMine;
			this.poolProfit = addrProfit;
			this.poolBouns = addrBonus;
			this.poolExc = addrExc;
			this.poolDestory = addrDestroy;
			this.usdtAddress = addrUSDT;
		}
	}
</script>

<style scoped>
	.age-dapp-container {
		font-family: 'Arial', sans-serif;
		max-width: 800px;
		margin: 0 auto;
		padding: 20px;

		border-radius: 12px;
		color: white;
		box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
	}

	.age-back-button {
		background: rgba(255, 255, 255, 0.1);
		border: 2px solid rgba(255, 255, 255, 0.3);
		color: white;
		padding: 10px 24px;
		border-radius: 8px;
		cursor: pointer;
		font-size: 16px;
		font-weight: 600;
		transition: all 0.3s ease;
		backdrop-filter: blur(10px);
		margin-bottom: 20px;
	}

	.age-back-button:hover:not(:disabled) {
		background: rgba(255, 255, 255, 0.2);
		border-color: rgba(255, 255, 255, 0.5);
		transform: translateY(-2px);
	}

	.age-back-button:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	.loading-spinner {
		display: inline-block;
		width: 16px;
		height: 16px;
		border: 2px solid rgba(255, 255, 255, 0.3);
		border-radius: 50%;
		border-top-color: white;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}

	.age-main-content {
		background: rgba(255, 255, 255, 0.1);
		border-radius: 12px;
		padding: 24px;
		backdrop-filter: blur(10px);
	}

	.age-main-content h2 {
		margin-top: 0;
		margin-bottom: 20px;
		font-size: 28px;
		text-align: center;
	}

	.age-info-section {
		text-align: center;
	}

	.age-info-section p {
		font-size: 18px;
		margin-bottom: 24px;
		opacity: 0.9;
	}

	.age-stats {
		display: flex;
		justify-content: center;
		gap: 40px;
		flex-wrap: wrap;
	}

	.stat-item {
		background: rgba(255, 255, 255, 0.05);
		padding: 12px 20px;
		border-radius: 8px;
		min-width: 180px;
		text-align: left;
	}

	.stat-label {
		font-weight: 600;
		opacity: 0.8;
		
	}

	.stat-value {
		font-weight: 700;
		color: #f0b90b;
		font-size: 10px;
		/* 币安链主题色 */
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.age-dapp-container {
			padding: 15px;
		}

		.age-stats {
			flex-direction: column;
			gap: 15px;
		}

		.stat-item {
			min-width: auto;
		}
	}
</style>